import React from "react";
import { Box, Button } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

const ConstructionProgressHeader = ({
  editMode,
  onEditSequence,
  onSave,
  onCancel,
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        justifyContent:"center",
        alignItems: "center",
        px: 2,
        py: 1,
      }}
    >

      <Box>
        {!editMode ? (
          <Button variant="contained" onClick={onEditSequence} sx={{ mr: 1 }}>
            Edit Sequence
          </Button>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={onSave}
              sx={{ mr: 1 }}
            >
              Save Sequence
            </Button>
            <Button
              variant="outlined"
              color="error"
              startIcon={<CancelIcon />}
              onClick={onCancel}
            >
              Cancel
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default ConstructionProgressHeader;
